<template>
  <div>
    <h1 >Editar accesos para portal</h1>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <div class="row">
          <div class="col-md-6">
            <label>Concesionario</label>
            <a-input placeholder="Concesionario" v-model="$v.consensionary.$model" disabled/>
            <small class="text-danger" v-if="!$v.consensionary.required">Campo requerido. No debe estar vacío.</small><br>
          </div>
          <div class="col-md-6">
            <label>Correo electrónico</label>
            <a-input placeholder="Correo electrónico" v-model="$v.email.$model" />
            <small class="text-danger" v-if="!$v.email.required">Campo requerido. No debe estar vacío.</small><br>
            <small class="text-danger" v-if="!$v.email">El correo electrónico no es válido, no debe contener espacios. Vuelve a intentarlo.</small><br>
            <small class="text-danger" v-if="!validateRegisteredEmail($v.email.$model)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9 col-sm-6">
          </div>
          <div class="col-lg-3 col-sm-6">
            <button
              :disabled="!(validateRegisteredEmail($v.email.$model) && !$v.$invalid)"
              v-if="clicked === 0"
              type="submit"
              class="btn btn-light px-5"
              @click="changeEmail()"
            >
              Guardar
            </button>
            <button
              :disabled="!(validateRegisteredEmail($v.email.$model) && !$v.$invalid)"
              v-else-if="clicked === 1"
              type="submit"
              class="btn btn-light px-5"
            >
              Guardando...
            </button>
            <button
              :disabled="!(validateRegisteredEmail($v.email.$model) && !$v.$invalid)"
              v-else-if="clicked === 2"
              type="submit"
              class="btn btn-light px-5"
            >
              Se ha guardado con éxito
            </button>
            <button
              :disabled="!(validateRegisteredEmail($v.email.$model) && !$v.$invalid)"
              v-else-if="clicked === 3"
              type="submit"
              class="btn btn-light px-5"
            >
              Ocurrió un error
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
// import { encrypt } from '@/config/headers'
import { required, helpers } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
const UPDATE_EMAIL_USER_PORTAL = gql`
  mutation updateEmailUserPortal($id: Int, $email: String) {
    updateEmailUserPortal(id: $id, email: $email){
      id
      concesionarioId
      email
    }
  }
`
const RESEND_EMAIL = gql`
  mutation resendPasswordPortal($email: String) {
    resendPasswordPortal(email: $email){
      success
    }
  }
`
const GET_CONCESIONARIO_USERS = gql`
  query getConcesionarioUsers{
    getConcesionarioUsers{
      id
      email
    }
  }
`
export default {
  data: function () {
    return {
      disabledButton: false,
      error: null,
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      email: this.$route.params.email,
      consensionary: this.$route.params.concesionario.name,
      mensaje: { color: '', texto: '' },
      registeredEmail: {},
      getConcesionarioUsers: [],
      data: {},
      clicked: 0,
    }
  },
  apollo: {
    getConcesionarioUsers: {
      query: GET_CONCESIONARIO_USERS,
      result({ data }) {
        this.getConcesionarioUsers = this.getConcesionarioUsers.reduce((map, item) => {
          map[item.email] = 1
          return map
        }, {})
        // console.log(this.getConcesionarioUsers)
      },
      context: headers(),
    },
  },
  methods: {
    changeEmail() {
      // this.clicked = true
      this.clicked = 1
      // console.log(user)
      this.$apollo.mutate({
        mutation: UPDATE_EMAIL_USER_PORTAL,
        context: headers(),
        variables: { id: parseInt(this.id), email: this.email },
      })
        .then(() => {
          // console.log(data)
          this.clicked = 2
          this.$router.push('/portal/usuarios')
          // this.resendEmail()
        })
        .catch(error => {
          this.clicked = 3
          console.log(error)
        })
    },
    resendEmail() {
      this.$apollo.mutate({
        mutation: RESEND_EMAIL,
        context: headers(),
        variables: { email: this.email },
      })
        .then(() => {
          this.clicked = 2
          this.$router.push('/portal/usuarios')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredEmail(email) {
      if (this.getConcesionarioUsers[email.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    console.log(this.$route.params)
  },
  validations: {
    email: { required, email },
    consensionary: { required },
  },
}
</script>
